import axios from "axios";
import store from "../../store/index";

export default {
  name: "shellgenerate",
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      isImporting: false,
      isChecking: true, // hides the import UI until checkExistingShells() completes
      _pollTimer: null,
    };
  },

  computed: {
    selectedStudyId() {
      return store.getters.getStudyIs;
    },
  },

  watch: {
    // Handles case where study changes while on this page
    selectedStudyId(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.stopPolling();
        this.checkExistingShells();
      }
    },
  },

  async mounted() {
    const studyId = store.getters.getStudyIs;
    if (studyId) {
      // studyId already available — check immediately
      await this.checkExistingShells();
    } else {
      // studyId not ready yet — poll until it arrives
      console.log("[ShellGenerate] studyId not ready — starting poll...");
      this.startPolling();
    }
  },

  beforeUnmount() {
    this.stopPolling();
  },

  methods: {
    startPolling() {
      let attempts = 0;
      const maxAttempts = 33; // ~10 seconds max

      this._pollTimer = setInterval(async () => {
        attempts++;
        const studyId = store.getters.getStudyIs;
        console.log(`[ShellGenerate] Poll attempt ${attempts}, studyId =`, studyId);

        if (studyId) {
          this.stopPolling();
          await this.checkExistingShells();
        } else if (attempts >= maxAttempts) {
          this.stopPolling();
          console.error("[ShellGenerate] studyId never became available after 10s");
        }
      }, 300);
    },

    stopPolling() {
      if (this._pollTimer) {
        clearInterval(this._pollTimer);
        this._pollTimer = null;
      }
    },

    async checkExistingShells() {
      const idtoken = store.getters.getIdToken;
      const studyId = store.getters.getStudyIs;

      if (!studyId) {
        console.warn("[ShellGenerate] checkExistingShells called with no studyId — skipping");
        return;
      }

      try {
        const res = await axios.get(
          `${this.baseurl}/stats-python/shellconfig/study/${studyId}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        // If shells already exist, redirect to the list page
        if (res.data && res.data.length > 0) {
          console.log("[ShellGenerate] Shells found — redirecting to /shells");
          this.$router.replace("/shells");
        } else {
          this.isChecking = false; // no shells found — safe to show import UI
        }
      } catch (err) {
        // No shells or error — stay and show Import button
        console.log("[ShellGenerate] No existing shells found, showing import option.");
        this.isChecking = false;
      }
    },

    async importShell() {
      const idtoken = store.getters.getIdToken;
      const studyId = store.getters.getStudyIs;

      if (!confirm("Are you sure you want to import the default shell for this study?")) return;

      try {
        this.isImporting = true;

        const response = await axios.get(
          `${this.baseurl}/stats-python/shellconfig/default-template/${studyId}`,
          {
            headers: {
              Authorization: `Bearer ${idtoken}`,
              "Content-Type": "application/json",
            },
          }
        );

        console.log("[ShellGenerate] Import response:", response.data);
        alert("Shell imported successfully!");
        this.$router.push("/shells");
      } catch (error) {
        console.error("[ShellGenerate] Import error:", error.response?.data || error);
        alert("Failed to import shell. Please try again.");
      } finally {
        this.isImporting = false;
      }
    },
  },
};